import lodash from 'lodash'
import moment from 'moment'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import uuid from 'uuid'

import LoaderOverlay from '../../../../../../1stlog-ui/src/components/LoaderOverlay'
import { usePrevious } from '../../../../../../1stlog-ui/src/hooks'
import { toast } from '../../../../../../1stlog-ui/src/utils'
import { useProducts } from '../../../Products'
import useOrderEntry from '../../../useOrderEntry'
import useProvider from '../useProvider'
import useRelevantTransportFields from '../useRelevantTransportFields'

const ProductLoader = (props) => {
  const { isPickup } = props

  const { currentCustomer } = useOrderEntry()

  const { products, setProducts } = useProducts()

  const [isLoading, setIsLoading] = useState(false)

  const {
    date,
    pickupCountry,
    pickupZip,
    deliveryCountry,
    deliveryZip,
    isPickupManualDisposition,
    isDeliveryManualDisposition,
    pickupAddress,
    deliveryAddress,
  } = useRelevantTransportFields()

  const lastUuid = useRef()

  const provider = useProvider() ?? {}

  const handleProductRequest = async (payload) => {
    // console.log("handleProductRequest", payload)
    let result = []
    const thisUuid = uuid()
    lastUuid.current = thisUuid
    setIsLoading(true)
    try {
      const { requestProducts } = provider
      result = await requestProducts(payload)
    } catch (err) {
      console.error('Failed to handle product request', err)
      toast.error('Laden der Produkte fehlgeschlagen!')
    } finally {
      // check if its still the latest request
      if (thisUuid === lastUuid.current) {
        setProducts(result)
        setIsLoading(false)
      }
    }
  }

  // request payload
  const payload = useMemo(() => {
    if (
      !pickupCountry ||
      !pickupZip ||
      !deliveryCountry ||
      !deliveryZip ||
      !date ||
      !provider
    ) {
      return undefined
    }
    if (isPickup && isPickupManualDisposition) {
      return undefined
    }
    if (!isPickup && isDeliveryManualDisposition) {
      return undefined
    }
    return {
      customerId: lodash.get(currentCustomer, 'id'),
      date: moment(date).format('YYYY-MM-DD'),
      pickupAddress: {
        ...pickupAddress,
        country: pickupCountry,
        zip: pickupZip,
      },
      deliveryAddress: {
        ...deliveryAddress,
        country: deliveryCountry,
        zip: deliveryZip,
      },
      isPickupRequest: isPickup,
    }
  }, [
    isPickup,
    date,
    pickupCountry,
    pickupZip,
    deliveryCountry,
    deliveryZip,
    provider,
    isPickupManualDisposition,
    isDeliveryManualDisposition,
  ])

  // request new products only when values are updated and valid
  const previousPayload = usePrevious(payload)
  const previousProvider = usePrevious(provider)
  useEffect(() => {
    if (!payload) {
      return
      // setProducts(undefined)
    }
    if (
      payload &&
      provider &&
      (!lodash.isEqual(payload, previousPayload) ||
        !lodash.isEqual(provider, previousProvider))
    ) {
      handleProductRequest(payload)
    }
  }, [payload])

  return (
    <>
      <LoaderOverlay isLoading={isLoading} />
    </>
  )
}

export default ProductLoader
